import React from "react";
import PropTypes from "prop-types";
import { PiWarningCircle } from "react-icons/pi";
import { Button } from "@/components/buttons";

/**
 * DeleteCoBorrowerModal — feature-scoped confirmation modal for co-borrower deletion.
 *
 * Opened via the overlay system: `openModal(key, DeleteCoBorrowerModal, { coApplicant, onConfirm })`.
 * `handleClose` is injected automatically by OverlayModal.
 */
export default function DeleteCoBorrowerModal({ handleClose, coApplicant, onConfirm }) {
  const handleDelete = () => {
    onConfirm?.();
    handleClose?.();
  };

  return (
    <div className="p-6">
      <div className="flex flex-col items-center text-center">
        <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-amber-100">
          <PiWarningCircle className="size-6 text-amber-600" aria-hidden="true" />
        </div>
        <h3 className="mt-4 text-lg font-semibold text-gray-900 dark:text-white">
          Delete Co-Borrower
        </h3>
        <p className="mt-2 text-sm text-gray-600 dark:text-slate-400">
          Are you sure you want to delete
          <strong>{` ${coApplicant?.firstName} ${coApplicant?.lastName}`}</strong>?
        </p>
        <p className="mt-1 text-sm text-gray-500 dark:text-slate-500">
          This action cannot be undone.
        </p>
      </div>
      <div className="mt-6 flex justify-end gap-3">
        <Button variant="outline" label="Cancel" onClick={handleClose} />
        <Button variant="danger" label="Yes, Delete!" onClick={handleDelete} />
      </div>
    </div>
  );
}

DeleteCoBorrowerModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  coApplicant: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

